export default __webpack_public_path__ + "static/media/Clock.db5e5b0a.svg";